import { Component } from '@angular/core';
import { SimulatorType } from '../../../core/enums/simulator-type.enum';

import { SimulatorConfig } from '../../../core/models/simulation.model';
import { CubeTrendSimulatorComponent } from '../../../common/cube-trend-simulator/cube-trend-simulator.component';

@Component({
  selector: 'app-cube-trend-absolute-permeability',
  imports: [CubeTrendSimulatorComponent],
  standalone: true,
  templateUrl: './cube-trend-absolute-permeability.component.html',
  styleUrl: './cube-trend-absolute-permeability.component.scss',
})
export class CubeTrendAbsolutePermeabilityComponent {
  readonly config: SimulatorConfig = {
    title: 'Subsample - Cube Trend Absolute Permeability Simulation',
    simulatorType: SimulatorType.SubsampleCubeTrendKabs,
  };
}
